const stock_bot = {
  title: 'Stock Bot',
  panoramica: 'Panoramica',
  dettagli: 'Dettagli',
  data_until_today: 'Valori attuali',
  data_until_end_of_last_year: 'Anno precedente',
  category_totals_title: 'Distribuzione valore per categoria',
  total: 'Totale',
  deposit_category_table_title: 'Categorie per deposito',
  category_table_title: 'Totali categorie',
  deposit_bar_chart_title: 'Valore per deposito',
  warehouse: 'Deposito',
  category: 'Categoria',
  details_table_title: 'Dettaglio articoli',
  search_placeholder: 'Cerca...',
  col_mag_cod: 'Cod. deposito',
  col_mag_sigla: 'Sigla deposito',
  col_codmag: 'Cod. magazzino',
  col_codice_articolo: 'Codice articolo',
  col_descrizione: 'Descrizione',
  col_clamer: 'Clamer',
  col_famiglia: 'Famiglia',
  col_settore: 'Settore',
  col_giacenza: 'Giacenza',
  col_valore: 'Valore',
  col_ultven_locale: 'Ult. vendita locale',
  col_primo_arr: 'Primo arrivo',
  col_cpa_anprec: 'CPA anno prec.',
  col_ultven_globale: 'Ult. vendita globale',
  col_mesi_copertura: 'Mesi copertura',
  col_categoria: 'Categoria',
  col_valore_netto: 'Valore netto',
  analyze_selected: 'Analizza selezionati',
  analysis: 'Analisi',
  analysis_warehouse: 'Magazzino',
  analysis_stock: 'Giacenza',
  analysis_value: 'Valore',
  analysis_cmp: 'CMP',
  analysis_pieces_short: 'pz',
  analysis_months_short: 'm',
  analysis_cpa_global: 'CPA globale {year} (netto resi)',
  analysis_thresholds: 'Soglie',
  vivo_72_title: 'Perché VIVO_72:',
  vivo_72_intro: "questa riga rappresenta l'eccedenza che supera i 72 mesi di copertura — fascia oltre 72 mesi.",
  vivo_72_coverage_pre: "La copertura globale dell'articolo è pari a",
  vivo_72_coverage_suf: 'mesi (giacenza globale / cpa mensile globale).',
  vivo_72_local_quota_pre: 'La giacenza',
  vivo_72_local_quota_suf: 'corrisponde alla quota VIVO_72 di questo magazzino (vedi sotto).',
  vivo_72_breakdown_global: "1) Ripartizione globale dell'articolo (somma su tutti i magazzini in cui è classificato VIVO):",
  vivo_72_breakdown_global_total: 'Giacenza VIVO totale',
  vivo_72_splits_in: 'ripartita in:',
  vivo_72_breakdown_local: '2) Quota in questo magazzino (quote globali ripartite in proporzione a qta_netta_loc / giac_residuo_glob):',
  vivo_72_formula_hint: 'Le quote globali si calcolano dalla giacenza VIVO totale e dalla cpa: q_ok = LEAST(giac, 4×cpa), q_48 = LEAST(MAX(giac − 4×cpa, 0), 2×cpa), q_72 = MAX(giac − 6×cpa, 0).',
  vivo_48_title: 'Perché VIVO_48:',
  vivo_48_intro: 'questa riga rappresenta la quota di giacenza che copre la fascia 48–72 mesi (banda di 24 mesi dopo la quota VIVO_OK) — fascia 48–72 mesi.',
  vivo_48_local_quota_suf: 'corrisponde alla quota VIVO_48 di questo magazzino (vedi sotto).',
  vivo_ok_title: 'Perché VIVO_OK:',
  vivo_ok_intro: 'questa riga rappresenta la quota di giacenza necessaria a coprire i primi 48 mesi di consumo — fascia 0–48 mesi.',
  vivo_ok_coverage_pre: "La copertura globale dell'articolo è pari a",
  vivo_ok_coverage_suf: 'mesi (giacenza globale / cpa mensile globale).',
  vivo_ok_local_quota_pre: 'La giacenza',
  vivo_ok_local_quota_suf: 'corrisponde alla quota VIVO_OK di questo magazzino (vedi sotto).',
  super_new_title: 'Perché SUPER_NEW:',
  super_new_intro_pre: "la prima traccia di presenza in casa dell'articolo è del",
  super_new_intro_mid: ', dopo la soglia del',
  super_new_intro_suf: '(ultimi 24 mesi).',
  super_new_formula_a: 'è la data più antica tra:',
  super_new_formula_b: '(bolla arrivo fornitore)',
  super_new_formula_c: 'escluse sentinelle 1970',
  super_new_formula_d: '(prima vendita)',
  super_new_formula_e: "escluse sentinelle 1970. Se anche una sola di queste fosse precedente alla soglia, l'articolo NON sarebbe SUPER_NEW.",
  super_new_first_arr_pre: 'Primo arrivo registrato in bolla:',
  super_new_global_note: "Categoria GLOBALE: vale in tutti i magazzini in cui l'articolo è presente.",
}

export default stock_bot
